import React, { useState } from 'react';
import { Alert, Button, Col, FormGroup, Input, Label } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import * as clientCredentialActions from '../../actions/clientCredentialActions';

// Migrated from redux-form to react-hook-form. accessType radios were already
// local state; only clientName was a redux-form field.
const ClientCredentialForm = ({ handleCancel, toggle }) => {
  const dispatch = useDispatch();
  const currentStore = useSelector((state) => state.store.one);
  const clientCredential = useSelector((state) => state.clientCredential);
  const { register, handleSubmit } = useForm({ defaultValues: { clientName: '' } });
  const [accessType, setAccessType] = useState('public');
  const [isFormVisible, setIsFormVisible] = useState(true);
  const [clientId, setClientId] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);

  const onSubmit = (values) => {
    let clientCredentialValue = values.id ? values : { ...values, storeId: currentStore.storeId };
    clientCredentialValue = { ...clientCredentialValue, credentialType: accessType === 'internal' ? 'private' : accessType };
    dispatch(clientCredentialActions.clearRegisterError());
    dispatch(clientCredentialActions.register(clientCredentialValue)).then((response) => {
      setClientId(response.data.clientId);
      setClientSecret(response.data.clientSecret);
      setIsFormVisible(false);
    });
  };

  const handleAccessTypeChange = (e) => setAccessType(e.target.value);

  const onCancel = () => {
    handleCancel();
    toggle();
    dispatch(clientCredentialActions.clearRegisterError());
  };

  const copyToClipboard = (text) => navigator.clipboard.writeText(text);

  return (
    <div>
      {clientCredential.error && clientCredential.error.message && <Alert color="danger">{clientCredential.error.message}</Alert>}
      {isFormVisible ? (
        <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
          <FormGroup row>
            <Col md="3">
              <label htmlFor="clientName">Client Name</label>
            </Col>
            <Col md="8">
              <input {...register('clientName')} type="text" className="form-control" required />
            </Col>
          </FormGroup>
          <FormGroup tag="fieldset" className="mt-4">
            <Label tag="legend" className="mb-3">API Access Type</Label>

            <FormGroup check className="mb-3">
              <Label check className="d-flex align-items-start" style={{ cursor: 'pointer' }}>
                <Input type="radio" name="accessType" value="public" checked={accessType === 'public'} onChange={handleAccessTypeChange} className="mt-1" style={{ cursor: 'pointer' }} />
                <div className="ms-2">
                  <div className="fw-bold">Public API</div>
                  <small className="text-muted">For applications acting on behalf of users.</small>
                </div>
              </Label>
            </FormGroup>

            <FormGroup check className="mb-3">
              <Label check className="d-flex align-items-start" style={{ cursor: 'pointer' }}>
                <Input type="radio" name="accessType" value="internal" checked={accessType === 'internal'} onChange={handleAccessTypeChange} className="mt-1" style={{ cursor: 'pointer' }} />
                <div className="ms-2">
                  <div className="fw-bold">Private API</div>
                  <small className="text-muted">For system to system integration.</small>
                </div>
              </Label>
            </FormGroup>

            <FormGroup check>
              <Label check className="d-flex align-items-start" style={{ cursor: 'pointer' }}>
                <Input type="radio" name="accessType" value="sync_agent" checked={accessType === 'sync_agent'} onChange={handleAccessTypeChange} className="mt-1" style={{ cursor: 'pointer' }} />
                <div className="ms-2">
                  <div className="fw-bold">Sync Agent</div>
                  <small className="text-muted">For sync agent installations. Cannot generate tokens, only validates them.</small>
                </div>
              </Label>
            </FormGroup>
          </FormGroup>
          <div className="float-end">
            <Button type="button" color="secondary" className="me-2" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="submit" color="primary">
              Save
            </Button>
          </div>
        </form>
      ) : (
        <>
          <p>
            <strong>Client Id:</strong>&nbsp;
            <span className="bg-light">{clientId}</span>
            <button type="button" className="btn-transparent btn btn-secondary" onClick={() => copyToClipboard(clientId)}>
              <i className="fa-solid fa-clipboard" aria-hidden="true"></i>
            </button>
          </p>
          <p>
            <strong>Client Secret:</strong>&nbsp;
            <span className="bg-light">{clientSecret}</span>
            <button type="button" className="btn-transparent btn btn-secondary" onClick={() => copyToClipboard(clientSecret)}>
              <i className="fa-solid fa-clipboard" aria-hidden="true"></i>
            </button>
          </p>
          <div className="float-end">
            <Button type="button" color="primary" onClick={onCancel}>
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ClientCredentialForm;
